<template>
    <div>
        <card-header title="Edit Enrollment" icon="fa-pencil"/>

        <card-body>
            <enrollment-form :enrollment="enrollment" v-if="enrollment"  @loading="loading"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column is-1">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteEnrollment"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Enrollment?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        class="mr-3"
                        :disabled="!enrollment"
                        @click="submit"
                    ><i class="fas fa-check mr-2"></i>Save Enrollment
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import QuoteForm from "@/cards/reseller/QuoteForm";

    import {client as http} from '../../http_client';

    import async from 'async';
    import EnrollmentForm from "./EnrollmentForm";
    import moment from 'moment';

    export default {
        components: {QuoteForm, CardFooter, CardToolbar, CardBody, CardHeader, EnrollmentForm},
        props: ['card', 'props'],
        data() {
            return {
                enrollment: null,
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadQuote: function() {
                this.$emit('loading', true);

                async.parallel([
                    (cb) => {
                        http.get('courses').then(response => {
                            this.courses = response.data;
                            cb();
                        });
                    },
                    (cb) => {
                        http.get('enrollments/' + this.props.enrollId, {force: true}).then(response => {
                            response.data.created_at = moment(response.data.created_at).toDate();
                            response.data.completed_at = moment(response.data.completed_at).toDate();

                            // this.enrollment = {courseSelect: null, configSelect: null, ...response.data};

                            this.enrollment = response.data;

                            cb();
                        }).catch(err => {
                            console.log(err);
                            cb(err);
                        });
                    }
                ], err => {
                    if (err) console.log(err);
                    this.$emit('loading', false);
                });
            },
            submit: function() {
                let payload = {
                    created_at: (this.enrollment.created_at) ? moment(this.enrollment.created_at).format('YYYY-MM-DD HH:mm:ss') : null,
                    approved_at: (this.enrollment.approved_at) ? moment(this.enrollment.approved_at).format('YYYY-MM-DD HH:mm:ss') : null,
                    completed_at: (this.enrollment.completed_at) ? moment(this.enrollment.completed_at).format('YYYY-MM-DD HH:mm:ss') : null
                };

                this.$emit('loading', true);
                http.put('enrollments/' + this.props.enrollId, payload, {force: true}).then(response => {
                    this.$reloadCard('course-enrollments');
                    this.$reloadCard('user-details');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteEnrollment() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    http.delete('enrollments/' + this.props.enrollId).then(response => {
                        this.$reloadCard('course-enrollments');
                        this.$reloadCard('user-details');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            },
            loading: function(val) {
                this.$emit('loading', val);
            }
        },
        watch: {
            'props.enrollId': function() {
                this.dirty = null;
                this.loadQuote();
            },
            'enrollment': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this enrollment? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadQuote();
        }
    };
</script>
